<template>
  <div class="wrapper">
    <welcome :user-name="user.firstName" :info="displayInfo" />
    <!--time sheets -->
    <div v-if="user.permissions['TIME_SHEET']" class="section">
      <time-sheets-listing :hide-headers="true" :user-on-home-page="true" />
    </div>
    <!--expenses -->
    <div v-if="user.permissions['EXPENSE_REPORT']" class="section">
      <expenses-listing :hide-headers="true" :user-on-home-page="true" />
    </div>
  </div>
</template>

<script>
import Welcome from '../components/Welcome.vue';
import TimeSheetsListing from '../../time-sheets/features/time-sheets-listing/TimeSheetsListing.vue';
import ExpensesListing from '../../expenses/features/expenses-listing/ExpensesListing.vue';
import { ProfileGetters } from '@/app/features/profile/profile-listing.keys';
export default {
  name: 'ContractorHome',
  components: {
    Welcome,
    TimeSheetsListing,
    ExpensesListing
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    displayInfo() {
      const unreadNotificationCount = this.$store.state.unreadNotificationCount;
      return {
        unreadNotificationCount,
        lastLoginAt: this.accessEntries[1] ? this.accessEntries[1].initiatedAt : '' //the second entry in list of logins is the 'last logged in'
      };
    },
    accessEntries() {
      return this.$store.getters[ProfileGetters.GetRecentAccessEntries];
    }
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  .section {
    margin-top: 25px;
  }
}
</style>
